/** @format */

import {AreaChartMultiDataType} from '../index';

export const RECORD_KEYS: (keyof AreaChartMultiDataType)[] = ['name', 'month'];

const getPointKeys = (record: AreaChartMultiDataType): string[] => {
  const keys = Object.keys(record) as (keyof AreaChartMultiDataType)[];
  return keys.filter(key => !RECORD_KEYS.includes(key));
};

export {getPointKeys};
